<template>
  <div class="row">
    <div class="col-12 col-lg-6 g">
      <div class="card">
        <div class="card-header">
          <h4 class="mb-0">
            <i class="fa fa-paper-plane"></i>
            إشعار عام
          </h4>
        </div>
        <div class="card-body">
          <p class="text-muted">يصل كإشعار على الجوال لكل من سجّل جهازه في النظام، في التطبيقات القديمة (Expo) والجديدة (FCM).</p>

          <label class="d-block">إرسال إلى</label>
          <div class="audiences">
            <label v-for="a in audienceList" :key="a.key" class="audience" :class="{ on: form.audiences.includes(a.key) }" :for="'aud-' + a.key">
              <input type="checkbox" :id="'aud-' + a.key" :value="a.key" v-model="form.audiences">
              <span class="name">{{ a.name }}</span>
              <small class="text-muted" v-if="counts">
                {{ count(a.key) }} جهاز
                <span class="d-block">FCM {{ counts[a.key].fcm }} · Expo {{ counts[a.key].expo }}</span>
              </small>
            </label>
          </div>

          <div class="form-group mt-1">
            <label for="token-type">نوع الأجهزة</label>
            <select id="token-type" class="form-control" v-model="form.token_type">
              <option value="all">الكل (القديم والجديد)</option>
              <option value="fcm">التطبيقات الجديدة فقط (FCM)</option>
              <option value="expo">التطبيقات القديمة فقط (Expo)</option>
            </select>
          </div>
          <div class="form-group">
            <label for="p-title">عنوان الإشعار</label>
            <input id="p-title" class="form-control" v-model="form.title" maxlength="150">
          </div>
          <div class="form-group">
            <label for="p-body">نص الإشعار</label>
            <textarea id="p-body" class="form-control" rows="4" v-model="form.body" maxlength="1000"></textarea>
          </div>

          <div class="total" v-if="counts">
            سيصل إلى <strong>{{ total }}</strong> جهاز تقريباً
            <a href="javascript:;" class="mr-1" @click="loadCounts(true)"><i class="fa fa-refresh"></i> تحديث العدد</a>
          </div>
          <div class="total text-muted" v-else>جاري حساب عدد الأجهزة...</div>

          <button class="btn btn-primary btn-block mt-1" @click="send()" :disabled="sending">
            <i class="fa fa-paper-plane"></i>
            {{ sending ? 'جاري التجهيز...' : 'إرسال للجميع' }}
          </button>

          <hr>
          <label for="test-token">تجربة على جهاز واحد قبل الإرسال</label>
          <div class="input-group">
            <input id="test-token" class="form-control" dir="ltr" placeholder="FCM token أو ExponentPushToken[...]" v-model.trim="testToken">
            <div class="input-group-append">
              <button class="btn btn-outline-primary" @click="test()">تجربة</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-lg-6 g">
      <div class="card">
        <div class="card-header">
          <h5 class="mb-0"><i class="fa fa-history"></i> آخر الإشعارات</h5>
          <button class="btn btn-sm btn-outline-secondary" @click="loadHistory()"><i class="fa fa-refresh"></i></button>
        </div>
        <div class="card-body">
          <div v-for="b in history" :key="b._id" class="broadcast">
            <div class="head">
              <strong>{{ b.title }}</strong>
              <span class="badge" :class="'st-' + b.status">{{ statusLabel(b.status) }}</span>
            </div>
            <small class="text-muted d-block">{{ b.body }}</small>
            <small class="d-block">
              {{ b.audiences.map(audienceName).join('، ') }} · {{ typeName(b.token_type) }} · {{ date(b.created_at) }}
            </small>
            <div class="progress mt-50" v-if="b.total">
              <div class="progress-bar bg-success" :style="{ width: pct(b.sent, b.total) + '%' }"></div>
              <div class="progress-bar bg-danger" :style="{ width: pct(b.failed, b.total) + '%' }"></div>
            </div>
            <small class="num">
              وصل {{ b.sent }} · فشل {{ b.failed }} · من {{ b.total }}
            </small>
            <button v-if="b.status == 'sending' || b.status == 'preparing'" class="btn btn-sm btn-outline-danger mr-1" @click="stop(b)">
              <i class="fa fa-stop"></i> إيقاف
            </button>
          </div>
          <p v-if="!history.length" class="text-muted text-center mb-0">لم يُرسل أي إشعار عام بعد.</p>
          <small class="text-muted d-block mt-1">«فشل» غالباً جهاز حذف التطبيق أو تغيّر توكن الإشعارات عنده.</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      jwt: localStorage.getItem('jwt'),
      counts: null,
      history: [],
      sending: false,
      testToken: '',
      timer: null,
      form: { audiences: [], token_type: 'all', title: '', body: '' },
      audienceList: [
        { key: 'parents', name: 'أولياء الأمور' },
        { key: 'teachers', name: 'المعلمين' },
        { key: 'schools', name: 'المدارس' },
      ],
    };
  },
  computed: {
    total() {
      var g = this;
      return this.form.audiences.reduce(function(sum, a){ return sum + g.count(a); }, 0);
    },
  },
  created() {
    this.loadCounts(false);
    this.loadHistory();
    // Follows the progress of a broadcast that is being sent.
    var g = this;
    this.timer = setInterval(function(){
      if(g.history.some(function(b){ return b.status == 'sending' || b.status == 'preparing'; })) g.loadHistory();
    }, 4000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    count(key) {
      if(!this.counts) return 0;
      var c = this.counts[key];
      return this.form.token_type == 'fcm' ? c.fcm : this.form.token_type == 'expo' ? c.expo : c.fcm + c.expo;
    },
    audienceName(key) {
      return (this.audienceList.find(function(a){ return a.key == key; }) || {}).name || key;
    },
    typeName(t) {
      return { all: 'الكل', fcm: 'الجديد (FCM)', expo: 'القديم (Expo)' }[t] || t;
    },
    statusLabel(s) {
      return { preparing: 'جاري التجهيز', sending: 'جاري الإرسال', done: 'تم', stopped: 'موقوف' }[s] || s;
    },
    pct(n, total) {
      return total ? Math.round(n * 100 / total) : 0;
    },
    date(d) {
      return d ? new Date(d).toLocaleString('ar-EG-u-nu-latn', { dateStyle: 'medium', timeStyle: 'short' }) : '';
    },
    loadCounts(refresh) {
      var g = this;
      if(refresh) g.counts = null;
      $.post(api + '/admin/push/count', { jwt: this.jwt, refresh: refresh ? 'true' : '' }).then(function(r){
        if(r.status != 100) return alert(r.response, 200);
        g.counts = r.response;
      });
    },
    loadHistory() {
      var g = this;
      $.post(api + '/admin/push/history', { jwt: this.jwt }).then(function(r){
        if(r.status == 100) g.history = r.response;
      });
    },
    send() {
      if(!this.form.audiences.length) return alert('اختر فئة واحدة على الأقل.', 200);
      if(!this.form.title.trim() || !this.form.body.trim()) return alert('اكتب عنوان الإشعار ونصه.', 200);
      var names = this.form.audiences.map(this.audienceName).join('، ');
      if(!confirm('سيتم إرسال الإشعار إلى ' + names + ' (' + this.total + ' جهاز تقريباً). لا يمكن التراجع بعد وصوله. متابعة؟')) return;
      var g = this;
      g.sending = true;
      $.post(api + '/admin/push/send', {
        jwt: this.jwt,
        audiences: this.form.audiences,
        token_type: this.form.token_type,
        title: this.form.title,
        body: this.form.body,
      }).then(function(r){
        g.sending = false;
        if(r.status != 100) return alert(r.response, 200);
        g.form.title = '';
        g.form.body = '';
        g.loadHistory();
        alert('بدأ الإرسال، تابع التقدم في «آخر الإشعارات».', 100);
      }).fail(function(){
        g.sending = false;
        alert('تعذر الاتصال بالسيرفر', 200);
      });
    },
    test() {
      if(!this.testToken) return alert('اكتب التوكن.', 200);
      $.post(api + '/admin/push/test', {
        jwt: this.jwt,
        token: this.testToken,
        title: this.form.title || 'تجربة إشعار',
        body: this.form.body || 'هذا إشعار تجريبي من لوحة التحكم.',
      }).then(function(r){
        alert(r.response, r.status);
      });
    },
    stop(b) {
      if(!confirm('إيقاف إرسال «' + b.title + '»؟ الأجهزة التي وصلها الإشعار لن يُحذف منها.')) return;
      var g = this;
      $.post(api + '/admin/push/stop', { jwt: this.jwt, id: b._id }).then(function(){
        g.loadHistory();
      });
    },
  },
};
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.audiences {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}
@media (max-width: 480px) {
  .audiences {
    grid-template-columns: 1fr;
  }
}
.audience {
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  cursor: pointer;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.audience.on {
  border-color: #7367f0;
  background: rgba(115, 103, 240, 0.06);
}
.audience input {
  position: absolute;
  opacity: 0;
}
.audience input:focus-visible + .name {
  outline: 2px solid #7367f0;
}
.audience .name {
  font-weight: bold;
}
.audience small {
  font-variant-numeric: tabular-nums;
}
.total {
  background: #f6f6f9;
  border-radius: 8px;
  padding: 10px;
  font-variant-numeric: tabular-nums;
}
.broadcast {
  border-bottom: 1px solid #eee;
  padding: 10px 0;
}
.broadcast:last-of-type {
  border-bottom: 0;
}
.broadcast .head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.broadcast .head strong {
  flex: 1 1 auto;
}
.broadcast .head .badge {
  flex: 0 0 auto;
  width: auto;
}
.num {
  font-variant-numeric: tabular-nums;
}
.progress {
  height: 6px;
}
.st-preparing,
.st-sending {
  background: #fff3d6;
  color: #9a6700;
}
.st-done {
  background: #e3f6ec;
  color: #1e7d4f;
}
.st-stopped {
  background: #eee;
  color: #555;
}
</style>
